module.exports = __webpack_public_path__ + "img/_SDI9220-2-1000.a2218c91.webp";